export default __webpack_public_path__ + "static/media/services_parking_secure.9c268a69.svg";